export enum GpsDataType {
  BorderCrossing = 0,
  DepartureFromBase = 1,
  ReturnToBase = 2,
  Unknown = 3,
}
